import React, { FunctionComponent } from 'react'
import { useGetSelectedTheme, useIsDarkMode } from '@afterpaytouch/core'
import Image from 'next/image'
import { ILLUSTRATION_CONFIG, THEME_COLOR_MAP } from './constants'

import styles from './style.module.css'
import { IllustrationProps } from './types'

export const Illustration: FunctionComponent<IllustrationProps> = ({ name, alt, width, height, testId }) => {
  const isDarkMode = useIsDarkMode()
  const theme = useGetSelectedTheme()

  const colorScheme = isDarkMode ? 'dark' : 'light'
  const illustrationConfig = ILLUSTRATION_CONFIG[name]
  const illustration = illustrationConfig.variants[THEME_COLOR_MAP[theme]][colorScheme]

  const calculatedHeight = Number(width) / illustrationConfig.aspectRatio
  const roundedCalculatedHeight = Math.round(calculatedHeight)

  return <Image className={styles.image} src={illustration} alt={alt || ''} data-testid={testId} width={width} height={height || roundedCalculatedHeight} />
}
